var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgYoutube = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 18,
    viewBox: "0 0 26 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_570_10791)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.4258 2.8075C25.2767 2.26486 24.9857 1.77014 24.582 1.37263C24.1783 0.975112 23.6759 0.688661 23.1248 0.5418C21.1071 0 12.9868 0 12.9868 0C12.9868 0 4.86608 0.0164 2.84844 0.5582C2.29731 0.70507 1.79488 0.991536 1.39117 1.38907C0.987455 1.78661 0.696558 2.28134 0.547441 2.824C-0.0628477 6.3538 -0.29959 11.7324 0.564199 15.121C0.713331 15.6636 1.00424 16.1584 1.40794 16.5559C1.81165 16.9534 2.31408 17.2398 2.8652 17.3867C4.88284 17.9285 13.0034 17.9285 13.0034 17.9285C13.0034 17.9285 21.1238 17.9285 23.1413 17.3867C23.6925 17.2399 24.1949 16.9534 24.5987 16.5559C25.0024 16.1584 25.2933 15.6637 25.4424 15.121C26.0861 11.5862 26.2845 6.2109 25.4258 2.8075Z",
    fill: "#FF0000"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.4021 12.8057L17.1385 8.96387L10.4021 5.12207V12.8057Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_570_10791"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 18,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgYoutube);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/youtube.c6821e63f01e4b7d9543522d5fc16dfb.svg";